export const CAMPAIGN_PAGE_TEMPLATE_FETCH_REQUEST = 'CAMPAIGN_PAGE_TEMPLATE_FETCH_REQUEST';
export const CAMPAIGN_PAGE_TEMPLATE_FETCH_SUCCESS = 'CAMPAIGN_PAGE_TEMPLATE_FETCH_SUCCESS';
export const CAMPAIGN_PAGE_TEMPLATE_FETCH_FAILURE = 'CAMPAIGN_PAGE_TEMPLATE_FETCH_FAILURE';

export const USER_FETCH_REQUEST = 'USER_FETCH_REQUEST';
export const USER_FETCH_SUCCESS = 'USER_FETCH_SUCCESS';
export const USER_FETCH_FAILURE = 'USER_FETCH_FAILURE';

export const defaultThumbnail = 'https://content.jwplatform.com/thumbs/s9jd3Wk1-1280.jpg';

export const defaultSupportUserOfficeDetails = {
	compliance: true,
	disclaimer: 'Office compliance disclaimer',
	facebook: 'https://www.facebook.com/eMoneyAdvisor',
	firmName: 'eMoney Advisor',
	isComplianceParent: false,
	isFirmBrandingEnabled: true,
	linkedin: 'https://www.linkedin.com/in',
	locations: [{
		address: 'Four Radnor Corporate Center',
		address2: '100 Matsonford Rd., Suite 300',
		city: 'Radnor',
		officeLocationNumber: 1,
		state: 'PA',
		zip: '19087'
	}, {
		address: '8910 University Center Lane',
		address2: 'Suite 500',
		city: 'San Diego',
		officeLocationNumber: 2,
		state: 'CA',
		zip: '92122'
	}, {
		address: '100 Westminster Street',
		city: 'Providence',
		officeLocationNumber: 3,
		state: 'RI',
		zip: '02903'
	}],
	phone: '(610) 684-1100',
	twitter: 'https://twitter.com/eMoneyAdvisor',
	website: 'https://emoneyadvisor.com/'
};

export const defaultUserInfo = {
	disclaimers : [{
		key: 'termsOfService',
		value: 'Terms of Service',
		token: null
	},
	{
		key: 'security',
		value: 'Security',
		token: null
	},
	{
		key: 'privacyPolicy',
		value: 'Privacy Policy',
		token: null
	},
	{
		key: 'disclaimer',
		value: 'Disclaimer',
		token: null
	}]
};